<div class="add-container" [ngClass]="inboxEmailsData || inboxAttachementsData ? 'inbox-type' : ''">
    <div class="d-flex justify-content-between align-items-center">
        <h1 *ngIf="docData" class="add-title m-0 p-0">Adaugă un nou document(Completare)</h1>
        <h1 *ngIf="!docData" class="add-title m-0 p-0">Adaugă un nou document(Intrare)</h1>
        <button class="action-buttons-side" (click)="closeDialog()">x</button>
    </div>
    <div *ngIf="docData" class="mb-2">
        <span style="color: red; font-size: 16px;">(Registru selectat: <strong><u>{{ selectedSerieDocument
                    }}</u></strong>)</span>
    </div>

    <div [ngClass]="inboxEmailsData || inboxAttachementsData ? 'inbox-type-content mt-3' : ''">
        <div [ngClass]="inboxEmailsData || inboxAttachementsData ? 'add-doc-left' : ''">
            <form [formGroup]="form">
                <h3 class="m-0">Identificare Document</h3>
                <mat-divider class="divider-section"></mat-divider>
                <br>
                <div *ngIf="docData" class="row">
                    <div class="col-md-12">
                        <mat-form-field appearance="fill">
                            <mat-label>Tip emitere număr document nou </mat-label>
                            <mat-select formControlName="new_number">
                                <mat-option *ngFor="let option of newNumberOptions"
                                    [value]="option.id">{{option.name}}</mat-option>
                            </mat-select>
                            <mat-error
                                *ngIf="!form.controls['new_number'].valid && form.controls['new_number'].touched">
                                Câmp obligatoriu
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div *ngIf="!docData" class="row">
                    <div class="col-md-12">
                        <mat-form-field appearance="fill">
                            <mat-label>Registru/Serie/Lot</mat-label>
                            <mat-select formControlName="id_serie">
                                <mat-option *ngFor="let option of registreActiveSwitch"
                                    [value]="option.id">{{option.name}}</mat-option>
                            </mat-select>
                            <mat-error *ngIf="!form.controls['id_serie'].valid && form.controls['id_serie'].touched">
                                Câmp obligatoriu
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <ng-container *ngIf="(inboxEmailsData || inboxAttachementsData)">
                    <div class="row">
                        <div [ngClass]="form.get('registratura_number_type')?.value === 1 ? 'col-md-12' : 'col-md-6'">
                            <mat-form-field appearance="fill">
                                <mat-label>Registru/Serie/Lot</mat-label>
                                <mat-select formControlName="registratura_number_type"
                                    (selectionChange)="onRegistraturaTypeSelected($event.value)">
                                    <mat-option *ngFor="let option of registreOptions"
                                        [value]="option.id">{{option.name}}</mat-option>
                                </mat-select>
                                <mat-error
                                    *ngIf="!form.controls['registratura_number_type'].valid && form.controls['registratura_number_type'].touched">
                                    Câmp obligatoriu
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md-6" *ngIf="form.get('registratura_number_type')?.value === 2">
                            <mat-form-field appearance="fill">
                                <mat-label>Număr Document (Răspuns/Ieșire)</mat-label>
                                <input type="number" matInput formControlName="registratura_number" />
                                <mat-error
                                    *ngIf="!form.controls['registratura_number'].valid && form.controls['registratura_number'].touched">
                                    Câmp obligatoriu
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                </ng-container>
                <div class="row">
                    <div class="col-md-12">
                        <mat-form-field appearance="fill">
                            <mat-label>Procedură document</mat-label>
                            <mat-select formControlName="exit_document_format"
                                (selectionChange)="onProceduraIesireSelected($event.value)">
                                <mat-option *ngFor="let option of proceduriDocumentOptions"
                                    [value]="option.id">{{option.name}}</mat-option>
                            </mat-select>
                            <mat-error
                                *ngIf="!form.controls['exit_document_format'].valid && form.controls['exit_document_format'].touched">
                                Câmp obligatoriu
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-10">
                        <mat-form-field appearance="fill">
                            <mat-label>Cale de intrare</mat-label>
                            <mat-select formControlName="source" (selectionChange)="addSerie()">
                                <mat-option *ngFor="let optionSursa of surse" [value]="optionSursa.id">
                                    {{ optionSursa.name }}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="!form.controls['source'].valid && form.controls['source'].touched">
                                Câmp obligatoriu
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-2">
                        <button type="button" class="btn btn-sm btn-primary btn-add-serie w-100" (click)="addSerie()">
                            <i class="fa-solid fa-plus"></i>
                            Adaugă cale
                        </button>
                    </div>
                </div>

                <div *ngIf="!sourceArr.length" class="mb-3">
                    <mat-error>
                        Adăugați minim o cale de intrare
                    </mat-error>
                </div>

                <div *ngIf="sourceArr.length" class="mb-3">
                    <mat-chip-listbox aria-label="Căi de intrare">
                        <mat-chip *ngFor="let sursa of sourceArr; let i = index" (removed)="removeSerie(i)">
                            {{sursa.name}}
                            <button matChipRemove [attr.aria-label]="'remove ' + sursa.name">
                                <mat-icon class="serie-remove-icon">cancel</mat-icon>
                            </button>
                        </mat-chip>
                    </mat-chip-listbox>
                </div>

                <div class="row">
                    <div class="col-md-12">
                        <mat-form-field appearance="fill">
                            <mat-label>Tip Document</mat-label>
                            <input matInput [formControl]="tipDocumenteControl" [matAutocomplete]="autoTipDocumente"
                                (blur)="onTipDocumenteBlur()" />
                            <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                            <mat-autocomplete #autoTipDocumente="matAutocomplete" [displayWith]="displayTipDocumente"
                                (optionSelected)="onTipDocumenteSelected($event.option.value)">
                                <mat-option *ngIf="showTipDocumenteMessage" disabled>
                                    <span *ngIf="!tipDocumenteControl.value || tipDocumenteControl.value.length < 2">
                                        Vă rugăm să introduceți 2 caractere sau mai multe
                                    </span>
                                    <span
                                        *ngIf="isTipDocumenteLoading && tipDocumenteControl.value && tipDocumenteControl.value.length >= 2">Căutare...</span>
                                    <span
                                        *ngIf="!isTipDocumenteLoading && tipDocumenteLoadComplete && tipDocumente.length === 0 && tipDocumenteControl.value && tipDocumenteControl.value.length >= 2">
                                        Nu au fost găsite rezultate
                                    </span>
                                </mat-option>

                                <mat-option *ngFor="let doc of tipDocumente" [value]="doc">
                                    {{ doc.name }}
                                </mat-option>
                            </mat-autocomplete>
                            <mat-error *ngIf="!tipDocumenteControl.valid && tipDocumenteControl.touched">
                                Câmp obligatoriu
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <form [formGroup]="formEmitent">
                    <h3 class="m-0">Petent/Beneficiar</h3>
                    <mat-divider class="divider-section"></mat-divider>

                    <button (click)="toggleEmitentInfoForm()" class="btn-search my-2"
                        [ngClass]="showEmitentInfoForm ? 'active-btn' : 'default-btn'">
                        {{ showEmitentInfoForm ? 'Ascunde Formular' : 'Adaugă' }} Informații Cetățean/Persoană
                        Juridică/Instituție
                    </button>

                    <div class="divider-container mb-2">
                        <div class="line"></div>
                        <span class="text">IDENTIFICARE</span>
                        <div class="line"></div>
                        <button class="ms-2 btn-reset-form"
                            (click)="resetFormEmitent(this.formEmitent.get('id_address_type')?.value)">
                            <i class="fa fa-eraser"></i>
                            <span>Curăță</span>
                        </button>
                    </div>

                    <div class="row">
                        <div [ngClass]="formEmitent.get('id_address_type')?.value !== 4 ? 'col-md-4' : 'col-md-12'">
                            <mat-form-field appearance="fill">
                                <mat-label>Tip Persoană/Instituție</mat-label>
                                <mat-select formControlName="id_address_type"
                                    (selectionChange)="resetFormEmitent($event.value)">
                                    <mat-option [value]="-1">-- Alegeți --</mat-option>
                                    <mat-option [value]="1">Cetățean</mat-option>
                                    <mat-option [value]="2">Persoană Juridică</mat-option>
                                    <mat-option [value]="3">Instituție Extern</mat-option>
                                    <mat-option [value]="4">Instituție Intern</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <ng-container *ngIf="formEmitent.get('id_address_type')?.value === -1">
                            <div class="col-md-4">
                                <mat-form-field appearance="fill">
                                    <mat-label>Denumire</mat-label>
                                    <input type="text" matInput formControlName="denumire" />
                                    <mat-error
                                        *ngIf="!formEmitent.controls['denumire'].valid && formEmitent.controls['denumire'].touched">
                                        Câmp obligatoriu
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="col-md-4">
                                <mat-form-field appearance="fill">
                                    <mat-label>Persoană contact</mat-label>
                                    <input type="text" matInput formControlName="pers_contact" />
                                </mat-form-field>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="formEmitent.get('id_address_type')?.value === 1 || 
                            formEmitent.get('id_address_type')?.value === 2 ||
                            formEmitent.get('id_address_type')?.value === 3">
                            <div class="col-md-8">
                                <mat-form-field appearance="fill">
                                    <mat-label *ngIf="formEmitent.get('id_address_type')?.value === 1">Nume complet -
                                        Cetățean</mat-label>
                                    <mat-label *ngIf="formEmitent.get('id_address_type')?.value === 2">Căutare:
                                        Persoană Juridică => ID: n/a</mat-label>
                                    <mat-label *ngIf="formEmitent.get('id_address_type')?.value === 3">Căutare:
                                        Instituție Externă => ID: n/a</mat-label>
                                    <input matInput [formControl]="entitatiEmitentControl"
                                        [matAutocomplete]="autoEntitateEmitent" (change)="onEntitateEmitentChange()" />
                                    <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>

                                    <mat-autocomplete #autoEntitateEmitent="matAutocomplete"
                                        [displayWith]="displayEntitateEmitent"
                                        (optionSelected)="onEntitateEmitentSelected($event.option.value)">
                                        <mat-option *ngIf="showEntitatiEmitentMessage" disabled>
                                            <span
                                                *ngIf="!entitatiEmitentControl.value || entitatiEmitentControl.value.length < 2">
                                                Vă rugăm să introduceți 2 caractere sau mai multe
                                            </span>
                                            <span
                                                *ngIf="isEntitatiEmitentLoading && entitatiEmitentControl.value && entitatiEmitentControl.value.length >= 2">Căutare...</span>
                                            <span
                                                *ngIf="!isEntitatiEmitentLoading && entitatiEmitentLoadComplete && entitatiEmitent.length === 0 && entitatiEmitentControl.value && entitatiEmitentControl.value.length >= 2">
                                                Nu au fost găsite rezultate
                                            </span>
                                        </mat-option>

                                        <mat-option *ngFor="let entitate of entitatiEmitent" [value]="entitate">
                                            {{ entitate.denumire }}
                                        </mat-option>
                                    </mat-autocomplete>
                                    <mat-error
                                        *ngIf="!formEmitent.controls['denumire_select'].valid && formEmitent.controls['denumire_select'].touched">
                                        Câmp obligatoriu
                                    </mat-error>
                                </mat-form-field>
                            </div>
                        </ng-container>
                    </div>

                    <ng-container *ngIf="formEmitent.get('id_address_type')?.value === 1">
                        <div class="row">
                            <div class="col-md-4">
                                <mat-form-field appearance="fill">
                                    <mat-label>CNP/CIF/Identificator</mat-label>
                                    <input type="text" matInput [formControl]="entitatiEmitentByCNPControl"
                                        [matAutocomplete]="autoEntitateEmitentByCNP"
                                        (change)="onEntitateEmitentByCNPChange()" />
                                    <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                                    <mat-autocomplete #autoEntitateEmitentByCNP="matAutocomplete"
                                        [displayWith]="displayEntitateEmitentByCNP"
                                        (optionSelected)="onEntitateEmitentByCNPSelected($event.option.value)">
                                        <mat-option *ngIf="showEntitatiEmitentByCNPMessage" disabled>
                                            <span
                                                *ngIf="!entitatiEmitentByCNPControl.value || entitatiEmitentByCNPControl.value.length < 2">
                                                Vă rugăm să introduceți 2 caractere sau mai multe
                                            </span>
                                            <span
                                                *ngIf="isEntitatiEmitentByCNPLoading && entitatiEmitentByCNPControl.value && entitatiEmitentByCNPControl.value.length >= 2">Căutare...</span>
                                            <span
                                                *ngIf="!isEntitatiEmitentByCNPLoading && entitatiEmitentByCNPLoadComplete && entitatiEmitentByCNP.length === 0 && entitatiEmitentByCNPControl.value && entitatiEmitentByCNPControl.value.length >= 2">
                                                Nu au fost găsite rezultate
                                            </span>
                                        </mat-option>

                                        <mat-option *ngFor="let entitate of entitatiEmitentByCNP" [value]="entitate">
                                            {{ entitate.cnp_cui }}
                                        </mat-option>
                                    </mat-autocomplete>
                                    <mat-error
                                        *ngIf="!entitatiEmitentByCNPControl.valid && entitatiEmitentByCNPControl.touched">
                                        Câmp obligatoriu
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div class="col-md-4">
                                <mat-form-field appearance="fill">
                                    <mat-label>Email</mat-label>
                                    <input type="text" matInput formControlName="email" />
                                </mat-form-field>
                            </div>
                            <div class="col-md-4">
                                <mat-form-field appearance="fill">
                                    <mat-label>Telefon</mat-label>
                                    <input type="text" matInput formControlName="telefon" />
                                </mat-form-field>
                            </div>
                        </div>

                        <div *ngIf="this.entitatiEmitentControl.value?.data_deces || this.entitatiEmitentByCNPControl.value?.data_deces"
                            class="warning-label">Emitent decedat!</div>
                    </ng-container>

                    <ng-container
                        *ngIf="formEmitent.get('id_address_type')?.value === 1 ||
                        formEmitent.get('id_address_type')?.value === 2 || formEmitent.get('id_address_type')?.value === 3">
                        <div class="divider-container">
                            <div class="line"></div>
                            <span class="text">Sau introduceți/adăugare</span>
                            <div class="line"></div>
                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <mat-form-field appearance="fill">
                                    <mat-label>Denumire</mat-label>
                                    <input type="text" matInput formControlName="denumire" />
                                    <mat-error
                                        *ngIf="!formEmitent.controls['denumire'].valid && formEmitent.controls['denumire'].touched">
                                        Câmp obligatoriu
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div *ngIf="formEmitent.get('id_address_type')?.value !== 1" class="col-md-6">
                                <mat-form-field appearance="fill">
                                    <mat-label>Persoană contact</mat-label>
                                    <input type="text" matInput formControlName="pers_contact" />
                                </mat-form-field>
                            </div>

                            <div class="row" *ngIf="formEmitent.get('id_address_type')?.value === 2">
                                <div class="col-md-4">
                                    <mat-form-field appearance="fill">
                                        <mat-label>CNP/CIF/Identificator</mat-label>
                                        <input type="text" matInput [formControl]="entitatiEmitentByCNPControl"
                                            [matAutocomplete]="autoEntitateEmitentByCNP"
                                            (change)="onEntitateEmitentByCNPChange()" />
                                        <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                                        <mat-autocomplete #autoEntitateEmitentByCNP="matAutocomplete"
                                            [displayWith]="displayEntitateEmitentByCNP"
                                            (optionSelected)="onEntitateEmitentByCNPSelected($event.option.value)">
                                            <mat-option *ngIf="showEntitatiEmitentByCNPMessage" disabled>
                                                <span
                                                    *ngIf="!entitatiEmitentByCNPControl.value || entitatiEmitentByCNPControl.value.length < 2">
                                                    Vă rugăm să introduceți 2 caractere sau mai multe
                                                </span>
                                                <span
                                                    *ngIf="isEntitatiEmitentByCNPLoading && entitatiEmitentByCNPControl.value && entitatiEmitentByCNPControl.value.length >= 2">Căutare...</span>
                                                <span
                                                    *ngIf="!isEntitatiEmitentByCNPLoading && entitatiEmitentByCNPLoadComplete && entitatiEmitentByCNP.length === 0 && entitatiEmitentByCNPControl.value && entitatiEmitentByCNPControl.value.length >= 2">
                                                    Nu au fost găsite rezultate
                                                </span>
                                            </mat-option>

                                            <mat-option *ngFor="let entitate of entitatiEmitentByCNP"
                                                [value]="entitate">
                                                {{ entitate.cnp_cui }}
                                            </mat-option>
                                        </mat-autocomplete>
                                        <mat-error
                                            *ngIf="!entitatiEmitentByCNPControl.valid && entitatiEmitentByCNPControl.touched">
                                            Câmp obligatoriu
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="col-md-4">
                                    <mat-form-field appearance="fill">
                                        <mat-label>Email</mat-label>
                                        <input type="text" matInput formControlName="email" />
                                    </mat-form-field>
                                </div>
                                <div class="col-md-4">
                                    <mat-form-field appearance="fill">
                                        <mat-label>Telefon</mat-label>
                                        <input type="text" matInput formControlName="telefon" />
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>

                        <div *ngIf="formEmitent.get('id_address_type')?.value === 1" class="mb-2">
                            <mat-error
                                *ngIf="!formEmitent.get('denumire_select')?.value && !formEmitent.get('denumire')?.value">
                                Câmpul 'Nume complet - Cetățean' sau câmpul 'Denumire' este obligatoriu,
                                deci minim unul din câmpuri de completat.
                            </mat-error>
                        </div>
                        <div *ngIf="formEmitent.get('id_address_type')?.value === 2 ||
                            formEmitent.get('id_address_type')?.value === 3" class="mb-2">
                            <mat-error
                                *ngIf="!formEmitent.get('denumire_select')?.value && !formEmitent.get('denumire')?.value">
                                Câmpul 'Căutare: Persoană Juridică/Institutie Externă' sau câmpul 'Denumire' este
                                obligatoriu,
                                deci minim unul din câmpuri de completat.
                            </mat-error>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="formEmitent.get('id_address_type')?.value === 4">
                        <div class="row">
                            <div class="col-md-12">
                                <mat-form-field appearance="fill">
                                    <mat-label>Instituție/Direcție</mat-label>
                                    <input matInput [formControl]="directiiEmitentControl"
                                        [matAutocomplete]="autoDirectiiEmitent" (blur)="onDirectiiEmitentBlur()" />
                                    <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                                    <mat-autocomplete #autoDirectiiEmitent="matAutocomplete"
                                        [displayWith]="displayDirectiiEmitent"
                                        (optionSelected)="onDirectiiEmitentChange($event.option.value)">
                                        <mat-option *ngIf="filteredDirectiiEmitent.length === 0" disabled>
                                            Nu au fost găsite rezultate
                                        </mat-option>
                                        <mat-option *ngFor="let directie of filteredDirectiiEmitent" [value]="directie">
                                            {{ directie.name }}
                                        </mat-option>
                                    </mat-autocomplete>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <mat-form-field appearance="fill">
                                    <mat-label>Compartiment/Departament</mat-label>
                                    <input matInput [formControl]="compartimenteEmitentControl"
                                        [matAutocomplete]="autoCompartimenteEmitent"
                                        (blur)="onCompartimenteEmitentBlur()" />
                                    <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                                    <mat-autocomplete #autoCompartimenteEmitent="matAutocomplete"
                                        [displayWith]="displayCompartimenteEmitent"
                                        (optionSelected)="onCompartimenteEmitentSelected($event.option.value)">
                                        <mat-option *ngIf="showCompartimenteEmitentMessage" disabled>
                                            <span
                                                *ngIf="!compartimenteEmitentControl.value || compartimenteEmitentControl.value.length < 2">
                                                Vă rugăm să introduceți 2 caractere sau mai multe
                                            </span>
                                            <span
                                                *ngIf="isCompartimenteEmitentLoading && compartimenteEmitentControl.value && compartimenteEmitentControl.value.length >= 2">Căutare...</span>
                                            <span
                                                *ngIf="!isCompartimenteEmitentLoading && compartimenteEmitentLoadComplete && compartimenteEmitent.length === 0 && compartimenteEmitentControl.value && compartimenteEmitentControl.value.length >= 2">
                                                Nu au fost găsite rezultate
                                            </span>
                                        </mat-option>

                                        <mat-option *ngFor="let compartiment of compartimenteEmitent"
                                            [value]="compartiment">
                                            {{ compartiment.name }}
                                        </mat-option>
                                    </mat-autocomplete>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <mat-form-field appearance="fill">
                                    <mat-label>Alegeți un operator</mat-label>
                                    <mat-select formControlName="user_id"
                                        (selectionChange)="onOperatoriEmitentChange($event.value)">
                                        <!-- <mat-form-field class="px-2 sticky-input">
                                            <input matInput [formControl]="operatoriEmitentControl"
                                                (keydown)="$event.stopPropagation()" (click)="$event.stopPropagation()" />
                                        </mat-form-field> -->

                                        <mat-option [value]="-1">-- Alegeți --</mat-option>
                                        <mat-option *ngFor="let operator of filteredOperatoriEmitent"
                                            [value]="operator.id">
                                            {{ operator.name }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>
                    </ng-container>

                    <ng-container *ngIf="showEmitentInfoForm && (formEmitent.get('id_address_type')?.value === 1 ||
                        formEmitent.get('id_address_type')?.value === 2 ||
                        formEmitent.get('id_address_type')?.value === 3)">
                        <div class="divider-container">
                            <div class="line"></div>
                            <span class="text">ADRESĂ/SEDIU</span>
                            <div class="line"></div>
                        </div>

                        <div class="row">
                            <div class="col-md-4">
                                <mat-form-field appearance="fill">
                                    <mat-label>Țară</mat-label>
                                    <input matInput [formControl]="tariEmitentControl"
                                        [matAutocomplete]="autoTariEmitent" (blur)="onTariEmitentBlur()" />
                                    <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                                    <mat-autocomplete #autoTariEmitent="matAutocomplete"
                                        [displayWith]="displayTariEmitent"
                                        (optionSelected)="onTariEmitentChange($event.option.value)">
                                        <mat-option *ngIf="filteredTariEmitent.length === 0" disabled>
                                            Nu au fost găsite rezultate
                                        </mat-option>
                                        <mat-option *ngFor="let tara of filteredTariEmitent" [value]="tara">
                                            {{ tara.name }}
                                        </mat-option>
                                    </mat-autocomplete>
                                </mat-form-field>
                            </div>
                            <div class="col-md-4">
                                <mat-form-field appearance="fill">
                                    <mat-label>Județ</mat-label>
                                    <input matInput [formControl]="judeteEmitentControl"
                                        [matAutocomplete]="autoJudeteEmitent" (blur)="onJudeteEmitentBlur()" />
                                    <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                                    <mat-autocomplete #autoJudeteEmitent="matAutocomplete"
                                        [displayWith]="displayJudeteEmitent"
                                        (optionSelected)="onJudeteEmitentChange($event.option.value)">
                                        <mat-option *ngIf="filteredJudeteEmitent.length === 0" disabled>
                                            Nu au fost găsite rezultate
                                        </mat-option>
                                        <mat-option *ngFor="let judet of filteredJudeteEmitent" [value]="judet">
                                            {{ judet.name }}
                                        </mat-option>
                                    </mat-autocomplete>
                                </mat-form-field>
                            </div>
                            <div class="col-md-4">
                                <mat-form-field appearance="fill">
                                    <mat-label>Localitate</mat-label>
                                    <input matInput [formControl]="localitatiEmitentControl"
                                        [matAutocomplete]="autoLocalitatiEmitent" (blur)="onLocalitatiEmitentBlur()" />
                                    <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                                    <mat-autocomplete #autoLocalitatiEmitent="matAutocomplete"
                                        [displayWith]="displayLocalitatiEmitent"
                                        (optionSelected)="onLocalitatiEmitentSelected($event.option.value)">
                                        <mat-option *ngIf="showLocalitatiEmitentMessage" disabled>
                                            <span
                                                *ngIf="!localitatiEmitentControl.value || localitatiEmitentControl.value.length < 2">
                                                Vă rugăm să introduceți 2 caractere sau mai multe
                                            </span>
                                            <span
                                                *ngIf="isLocalitatiEmitentLoading && localitatiEmitentControl.value && localitatiEmitentControl.value.length >= 2">Căutare...</span>
                                            <span
                                                *ngIf="!isLocalitatiEmitentLoading && localitatiEmitentLoadComplete && localitatiEmitent.length === 0 && localitatiEmitentControl.value && localitatiEmitentControl.value.length >= 2">
                                                Nu au fost găsite rezultate
                                            </span>
                                        </mat-option>

                                        <mat-option *ngFor="let localitate of localitatiEmitent" [value]="localitate">
                                            {{ localitate.name }}
                                        </mat-option>
                                    </mat-autocomplete>
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-4">
                                <mat-form-field appearance="fill">
                                    <mat-label>Sector</mat-label>
                                    <mat-select formControlName="sector">
                                        <mat-option value="-1">--Alegeți--</mat-option>
                                        <mat-option value="1">Sector 1</mat-option>
                                        <mat-option value="2">Sector 2</mat-option>
                                        <mat-option value="3">Sector 3</mat-option>
                                        <mat-option value="4">Sector 4</mat-option>
                                        <mat-option value="5">Sector 5</mat-option>
                                        <mat-option value="6">Sector 6</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-md-4 d-flex flex-row gap-1">
                                <mat-form-field appearance="fill">
                                    <mat-label>Stradă</mat-label>
                                    <input matInput [formControl]="straziEmitentControl"
                                        [matAutocomplete]="autoStraziEmitent" (blur)="onStraziEmitentBlur()" />
                                    <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                                    <mat-autocomplete #autoStraziEmitent="matAutocomplete"
                                        [displayWith]="displayStraziEmitent"
                                        (optionSelected)="onStraziEmitentSelected($event.option.value)">
                                        <mat-option *ngIf="showStraziEmitentMessage" disabled>
                                            <span
                                                *ngIf="!straziEmitentControl.value || straziEmitentControl.value.length < 2">
                                                Vă rugăm să introduceți 2 caractere sau mai multe
                                            </span>
                                            <span
                                                *ngIf="isStraziEmitentLoading && straziEmitentControl.value && straziEmitentControl.value.length >= 2">Căutare...</span>
                                            <span
                                                *ngIf="!isStraziEmitentLoading && straziEmitentLoadComplete && straziEmitent.length === 0 && straziEmitentControl.value && straziEmitentControl.value.length >= 2">
                                                Nu au fost găsite rezultate
                                            </span>
                                        </mat-option>

                                        <mat-option *ngFor="let strada of straziEmitent" [value]="strada">
                                            {{ strada.name }}
                                        </mat-option>
                                    </mat-autocomplete>
                                </mat-form-field>
                                <button
                                    *ngIf="!isStraziEmitentLoading && straziEmitentLoadComplete && straziEmitent.length === 0 && straziEmitentControl.value && straziEmitentControl.value.length >= 2"
                                    type="button" class="btn-add-entry" (click)="addStraziEmitent()">
                                    <i class="icon fa fa-add"></i>
                                </button>
                            </div>
                            <div class="col-md-4">
                                <mat-form-field appearance="fill">
                                    <mat-label>Număr</mat-label>
                                    <input type="text" matInput formControlName="numar" />
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-3">
                                <mat-form-field appearance="fill">
                                    <mat-label>Bloc</mat-label>
                                    <input type="text" matInput formControlName="bloc" />
                                </mat-form-field>
                            </div>
                            <div class="col-md-3">
                                <mat-form-field appearance="fill">
                                    <mat-label>Scară</mat-label>
                                    <input type="text" matInput formControlName="scara" />
                                </mat-form-field>
                            </div>
                            <div class="col-md-3">
                                <mat-form-field appearance="fill">
                                    <mat-label>Apartament</mat-label>
                                    <input type="text" matInput formControlName="apartament" />
                                </mat-form-field>
                            </div>
                            <div class="col-md-3">
                                <mat-form-field appearance="fill">
                                    <mat-label>Cod Poștal</mat-label>
                                    <input type="text" matInput formControlName="cod_postal" />
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row">
                            <div *ngIf="formEmitent.get('id_address_type')?.value === 1" class="col-md-4">
                                <mat-form-field appearance="fill">
                                    <mat-label>Număr document deces</mat-label>
                                    <input type="text" matInput formControlName="numar_deces" />
                                </mat-form-field>
                            </div>
                            <div *ngIf="formEmitent.get('id_address_type')?.value === 1" class="col-md-4">
                                <mat-form-field>
                                    <mat-label>Dată deces</mat-label>
                                    <input matInput [max]="today" [matDatepicker]="dateDecesPicker"
                                        formControlName="data_deces_input" placeholder="Dacă există..." readonly
                                        (focus)="dateDecesPicker.open()" />
                                    <mat-hint>ZZ/LL/AAAA</mat-hint>
                                    <mat-datepicker-toggle matIconSuffix
                                        [for]="dateDecesPicker"></mat-datepicker-toggle>
                                    <mat-datepicker #dateDecesPicker></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="col-md-4">
                                <mat-checkbox
                                    [ngClass]="formEmitent.get('id_address_type')?.value === 1 ? 'mt-md-2' : 'mb-2'"
                                    color="primary" formControlName="person_status">
                                    Verificare evidența persoanelor
                                </mat-checkbox>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <mat-form-field appearance="fill">
                                    <mat-label>Observații Emitent</mat-label>
                                    <textarea matInput formControlName="observatii"
                                        placeholder="Dacă există observații..."></textarea>
                                </mat-form-field>
                            </div>
                        </div>
                    </ng-container>
                </form>

                <h3 class="m-0">Informații Document</h3>
                <mat-divider class="divider-section"></mat-divider>
                <br>
                <div class="row">
                    <div class="col-md-6">
                        <mat-form-field appearance="fill">
                            <mat-label>Referire la Număr anterior (Intrare)</mat-label>
                            <input matInput formControlName="parent_no" />
                        </mat-form-field>
                    </div>
                    <div class="col-md-6">
                        <mat-form-field appearance="fill">
                            <mat-label>Anul - Documentului de Referință</mat-label>
                            <input matInput type="number" formControlName="parent_year" />
                        </mat-form-field>
                    </div>
                    <mat-hint class="mb-3"><span class="text-secondary fst-italic">Info: Dacă se completează numărul de
                            referință anterior, este obligatorie
                            introducerea de an -
                            document referință</span></mat-hint>
                </div>
                <div class="row">
                    <div class="col-md-3">
                        <mat-form-field appearance="fill">
                            <mat-label>Serie Emitent Extern</mat-label>
                            <input matInput formControlName="serie_pv" />
                        </mat-form-field>
                    </div>
                    <div class="col-md-3">
                        <mat-form-field appearance="fill">
                            <mat-label>Număr Emitent Extern</mat-label>
                            <input matInput formControlName="extern_numar" />
                        </mat-form-field>
                    </div>
                    <div class="col-md-3">
                        <mat-form-field>
                            <mat-label>Dată emitere(extern)</mat-label>
                            <input matInput [matDatepicker]="dateEmiterePicker" formControlName="extern_date_input"
                                placeholder="Dacă există..." readonly (focus)="dateEmiterePicker.open()" />
                            <mat-hint>ZZ/LL/AAAA</mat-hint>
                            <mat-datepicker-toggle matIconSuffix [for]="dateEmiterePicker"></mat-datepicker-toggle>
                            <mat-datepicker #dateEmiterePicker></mat-datepicker>
                        </mat-form-field>
                    </div>
                    <div class="col-md-3">
                        <mat-form-field>
                            <mat-label>Dată comunicare(extern)</mat-label>
                            <input matInput [matDatepicker]="dateComunicarePicker"
                                formControlName="data_comunicare_pv_input" readonly
                                (focus)="dateComunicarePicker.open()" />
                            <mat-hint>ZZ/LL/AAAA</mat-hint>
                            <mat-datepicker-toggle matIconSuffix [for]="dateComunicarePicker"></mat-datepicker-toggle>
                            <mat-datepicker #dateComunicarePicker></mat-datepicker>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <mat-form-field appearance="fill">
                            <mat-label>Observații Document</mat-label>
                            <textarea matInput formControlName="observatii"
                                placeholder="Observații/Mențiuni/Conținut..."></textarea>
                            <mat-hint style="color: red;">
                                <strong><i>Aici se notează observațiile/mențiunile/conținutul
                                        documentului/dosarului!</i></strong>
                            </mat-hint>
                            <mat-error
                                *ngIf="!form.controls['observatii'].valid && form.controls['observatii'].touched">
                                Câmp obligatoriu
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-8">
                        <mat-form-field appearance="fill">
                            <mat-label>Cuvinte cheie</mat-label>
                            <input matInput type="text" formControlName="keywords" />
                            <mat-error *ngIf="!form.controls['keywords'].valid && form.controls['keywords'].touched">
                                Câmp obligatoriu
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-4">
                        <mat-form-field appearance="fill">
                            <mat-label>Număr Pagini</mat-label>
                            <input matInput type="number" formControlName="no_pages" />
                            <mat-error *ngIf="!form.controls['no_pages'].valid && form.controls['no_pages'].touched">
                                Câmp obligatoriu
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <form [formGroup]="formExtern">
                    <div class="divider-container">
                        <div class="line"></div>
                        <span class="text">EMITENT EXTERN</span>
                        <div class="line"></div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <mat-form-field appearance="fill">
                                <mat-label>Denumire Emitent Extern*</mat-label>
                                <input type="text" matInput [formControl]="entitatiExternControl"
                                    [matAutocomplete]="autoEntitateExtern" (change)="onEntitateExternChange()" />
                                <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>

                                <mat-autocomplete #autoEntitateExtern="matAutocomplete"
                                    [displayWith]="displayEntitateExtern"
                                    (optionSelected)="onEntitateExternSelected($event.option.value)">
                                    <mat-option *ngIf="showEntitatiExternMessage" disabled>
                                        <span
                                            *ngIf="!entitatiExternControl.value || entitatiExternControl.value.length < 2">
                                            Vă rugăm să introduceți 2 caractere sau mai multe
                                        </span>
                                        <span
                                            *ngIf="isEntitatiExternLoading && entitatiExternControl.value && entitatiExternControl.value.length >= 2">Căutare...</span>
                                        <span
                                            *ngIf="!isEntitatiExternLoading && entitatiExternLoadComplete && entitatiExtern.length === 0 && entitatiExternControl.value && entitatiExternControl.value.length >= 2">
                                            Nu au fost găsite rezultate
                                        </span>
                                    </mat-option>

                                    <mat-option *ngFor="let entitate of entitatiExtern" [value]="entitate">
                                        {{ entitate.denumire }}
                                    </mat-option>
                                </mat-autocomplete>
                                <mat-error
                                    *ngIf="!formExtern.controls['denumire'].valid && formExtern.controls['denumire'].touched">
                                    Câmp obligatoriu
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-md-4">
                            <mat-form-field appearance="fill">
                                <mat-label>Email</mat-label>
                                <input type="text" matInput formControlName="email" />
                            </mat-form-field>
                        </div>
                        <div class="col-md-4">
                            <mat-form-field appearance="fill">
                                <mat-label>Telefon</mat-label>
                                <input type="text" matInput formControlName="telefon" />
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <mat-form-field appearance="fill">
                                <mat-label>Țară</mat-label>
                                <input matInput [formControl]="tariExternControl" [matAutocomplete]="autoTariExtern"
                                    (blur)="onTariExternBlur()" />
                                <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                                <mat-autocomplete #autoTariExtern="matAutocomplete" [displayWith]="displayTariExtern"
                                    (optionSelected)="onTariExternChange($event.option.value)">
                                    <mat-option *ngIf="filteredTariExtern.length === 0" disabled>
                                        Nu au fost găsite rezultate
                                    </mat-option>
                                    <mat-option *ngFor="let tara of filteredTariExtern" [value]="tara">
                                        {{ tara.name }}
                                    </mat-option>
                                </mat-autocomplete>
                            </mat-form-field>
                        </div>
                        <div class="col-md-4">
                            <mat-form-field appearance="fill">
                                <mat-label>Județ</mat-label>
                                <input matInput [formControl]="judeteExternControl" [matAutocomplete]="autoJudeteExtern"
                                    (blur)="onJudeteExternBlur()" />
                                <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                                <mat-autocomplete #autoJudeteExtern="matAutocomplete"
                                    [displayWith]="displayJudeteExtern"
                                    (optionSelected)="onJudeteExternChange($event.option.value)">
                                    <mat-option *ngIf="filteredJudeteExtern.length === 0" disabled>
                                        Nu au fost găsite rezultate
                                    </mat-option>
                                    <mat-option *ngFor="let judet of filteredJudeteExtern" [value]="judet">
                                        {{ judet.name }}
                                    </mat-option>
                                </mat-autocomplete>
                            </mat-form-field>
                        </div>
                        <div class="col-md-4">
                            <mat-form-field appearance="fill">
                                <mat-label>Localitate</mat-label>
                                <input matInput [formControl]="localitatiExternControl"
                                    [matAutocomplete]="autoLocalitatiExtern" (blur)="onLocalitatiExternBlur()" />
                                <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                                <mat-autocomplete #autoLocalitatiExtern="matAutocomplete"
                                    [displayWith]="displayLocalitatiExtern"
                                    (optionSelected)="onLocalitatiExternSelected($event.option.value)">
                                    <mat-option *ngIf="showLocalitatiExternMessage" disabled>
                                        <span
                                            *ngIf="!localitatiExternControl.value || localitatiExternControl.value.length < 2">
                                            Vă rugăm să introduceți 2 caractere sau mai multe
                                        </span>
                                        <span
                                            *ngIf="isLocalitatiExternLoading && localitatiExternControl.value && localitatiExternControl.value.length >= 2">Căutare...</span>
                                        <span
                                            *ngIf="!isLocalitatiExternLoading && localitatiExternLoadComplete && localitatiExtern.length === 0 && localitatiExternControl.value && localitatiExternControl.value.length >= 2">
                                            Nu au fost găsite rezultate
                                        </span>
                                    </mat-option>

                                    <mat-option *ngFor="let localitate of localitatiExtern" [value]="localitate">
                                        {{ localitate.name }}
                                    </mat-option>
                                </mat-autocomplete>
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-4">
                            <mat-form-field appearance="fill">
                                <mat-label>Sector</mat-label>
                                <mat-select formControlName="sector">
                                    <mat-option value="-1">--Alegeți--</mat-option>
                                    <mat-option value="1">Sector 1</mat-option>
                                    <mat-option value="2">Sector 2</mat-option>
                                    <mat-option value="3">Sector 3</mat-option>
                                    <mat-option value="4">Sector 4</mat-option>
                                    <mat-option value="5">Sector 5</mat-option>
                                    <mat-option value="6">Sector 6</mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                        <div class="col-md-4 d-flex flex-row gap-1">
                            <mat-form-field appearance="fill">
                                <mat-label>Stradă</mat-label>
                                <input matInput [formControl]="straziExternControl" [matAutocomplete]="autoStraziExtern"
                                    (blur)="onStraziExternBlur()" />
                                <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                                <mat-autocomplete #autoStraziExtern="matAutocomplete"
                                    [displayWith]="displayStraziExtern"
                                    (optionSelected)="onStraziExternSelected($event.option.value)">
                                    <mat-option *ngIf="showStraziExternMessage" disabled>
                                        <span
                                            *ngIf="!straziExternControl.value || straziExternControl.value.length < 2">
                                            Vă rugăm să introduceți 2 caractere sau mai multe
                                        </span>
                                        <span
                                            *ngIf="isStraziExternLoading && straziExternControl.value && straziExternControl.value.length >= 2">Căutare...</span>
                                        <span
                                            *ngIf="!isStraziExternLoading && straziExternLoadComplete && straziExtern.length === 0 && straziExternControl.value && straziExternControl.value.length >= 2">
                                            Nu au fost găsite rezultate
                                        </span>
                                    </mat-option>

                                    <mat-option *ngFor="let strada of straziExtern" [value]="strada">
                                        {{ strada.name }}
                                    </mat-option>
                                </mat-autocomplete>
                            </mat-form-field>
                            <button
                                *ngIf="!isStraziExternLoading && straziExternLoadComplete && straziExtern.length === 0 && straziExternControl.value && straziExternControl.value.length >= 2"
                                type="button" class="btn-add-entry" (click)="addStraziExtern()">
                                <i class="icon fa fa-add"></i>
                            </button>
                        </div>
                        <div class="col-md-4">
                            <mat-form-field appearance="fill">
                                <mat-label>Număr</mat-label>
                                <input type="text" matInput formControlName="numar" />
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-3">
                            <mat-form-field appearance="fill">
                                <mat-label>Bloc</mat-label>
                                <input type="text" matInput formControlName="bloc" />
                            </mat-form-field>
                        </div>
                        <div class="col-md-3">
                            <mat-form-field appearance="fill">
                                <mat-label>Scară</mat-label>
                                <input type="text" matInput formControlName="scara" />
                            </mat-form-field>
                        </div>
                        <div class="col-md-3">
                            <mat-form-field appearance="fill">
                                <mat-label>Apartament</mat-label>
                                <input type="text" matInput formControlName="apartament" />
                            </mat-form-field>
                        </div>
                        <div class="col-md-3">
                            <mat-form-field appearance="fill">
                                <mat-label>Cod Poștal</mat-label>
                                <input type="text" matInput formControlName="cod_postal" />
                            </mat-form-field>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <mat-form-field appearance="fill">
                                <mat-label>Observații Emitent Extern</mat-label>
                                <textarea matInput formControlName="observatii"
                                    placeholder="Dacă există observații..."></textarea>
                            </mat-form-field>
                        </div>
                    </div>
                </form>

                <ng-container *ngIf="showFormFiles">
                    <h3 class="m-0">Încărcați Documente <span
                            *ngIf="!(this.inboxEmailsData || this.inboxAttachementsData)" class="text-danger">(*)</span>
                    </h3>
                    <mat-divider class="divider-section"></mat-divider>
                    <br>
                    <form [formGroup]="formFiles">
                        <div class="solicitare-card__upload mb-2">
                            <div class="solicitare-card__upload-header">
                                <p class="upload-text">Documente</p>
                                <button class="upload-btn" (click)="fileInput.click()" type="button">
                                    <mat-icon class="upload-icon">cloud_upload</mat-icon>
                                    ÎNCARCĂ
                                </button>
                            </div>
                            <div class="solicitare-card__upload-files" *ngIf="
                                formFiles.value.files &&
                                formFiles.value.files.length > 0 &&
                                !uploading
                            ">
                                <div class="solicitare-card__upload-file" *ngFor="
                                    let uploadedFile of formFiles.value.files;
                                    let i = index
                                ">
                                    <span class="solicitare-card__upload-file-name">
                                        {{
                                        uploadedFile.original_name.length > 30
                                        ? (uploadedFile.original_name | slice : 0 : 30) + ".."
                                        : uploadedFile.original_name
                                        }}
                                    </span>
                                    <div class="d-flex gap-4 align-items-center">
                                        <button class="solicitare-card__upload-file-view" type="button"
                                            matTooltip="Vizualizează fișierul" (click)="downloadFile(uploadedFile)">
                                            <mat-icon class="btn-icon">visibility</mat-icon>
                                            <span class="btn-text">Vizualizează</span>
                                        </button>
                                        <button class="solicitare-card__upload-file-delete" type="button"
                                            matTooltip="Șterge fișierul încărcat" (click)="removeFile(i)">
                                            <img class="btn-img" src="../../../assets/icons/delete.svg" alt="" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div class="solicitare-card__upload-files" *ngIf="
                                formFiles.value.files &&
                                formFiles.value.files.length === 0 &&
                                !uploading
                            ">
                                <div class="solicitare-card__upload-file">
                                    <div class="w-100 text-center">
                                        <strong><i>Lipsă înregistrări</i></strong>
                                    </div>
                                </div>
                            </div>
                            <mat-spinner diameter="32" style="margin-right: 8px; margin-top: 4px"
                                *ngIf="uploading"></mat-spinner>

                            <input type="file"
                                accept=".png, .jpg, .jpeg, .gif, .pdf, .doc, .docx, .xls, .xlsx, .ods, .odt, .heic"
                                id="upload-file-input-0" #fileInput name="fileInput" (change)="addFile($event)" multiple
                                style="display: none" />
                        </div>
                    </form>
                </ng-container>

                <ng-container *ngIf="showFormDestinatie">
                    <h3 class="m-0">Destinație <span class="text-danger">(*)</span></h3>
                    <mat-divider class="divider-section"></mat-divider>
                    <br>
                    <form [formGroup]="formDestinatie">
                        <div class="row">
                            <div class="col-md-12">
                                <mat-form-field appearance="fill">
                                    <mat-label>Instituție/Direcție</mat-label>
                                    <input matInput [formControl]="directiiDestinatieControl"
                                        [matAutocomplete]="autoDirectiiDestinatie"
                                        (blur)="onDirectiiDestinatieBlur()" />
                                    <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                                    <mat-autocomplete #autoDirectiiDestinatie="matAutocomplete"
                                        [displayWith]="displayDirectiiDestinatie"
                                        (optionSelected)="onDirectiiDestinatieChange($event.option.value)">
                                        <mat-option *ngIf="filteredDirectiiDestinatie.length === 0" disabled>
                                            Nu au fost găsite rezultate
                                        </mat-option>
                                        <mat-option *ngFor="let directie of filteredDirectiiDestinatie"
                                            [value]="directie">
                                            {{ directie.name }}
                                        </mat-option>
                                    </mat-autocomplete>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <mat-form-field appearance="fill">
                                    <mat-label>Compartiment/Departament</mat-label>
                                    <input matInput [formControl]="compartimenteDestinatieControl"
                                        [matAutocomplete]="autoCompartimenteDestinatie"
                                        (blur)="onCompartimenteDestinatieBlur()" />
                                    <mat-icon matSuffix class="opacity-50 search-icon">search</mat-icon>
                                    <mat-autocomplete #autoCompartimenteDestinatie="matAutocomplete"
                                        [displayWith]="displayCompartimenteDestinatie"
                                        (optionSelected)="onCompartimenteDestinatieSelected($event.option.value)">
                                        <mat-option *ngIf="showCompartimenteDestinatieMessage" disabled>
                                            <span
                                                *ngIf="!compartimenteDestinatieControl.value || compartimenteDestinatieControl.value.length < 2">
                                                Vă rugăm să introduceți 2 caractere sau mai multe
                                            </span>
                                            <span
                                                *ngIf="isCompartimenteDestinatieLoading && compartimenteDestinatieControl.value && compartimenteDestinatieControl.value.length >= 2">Căutare...</span>
                                            <span
                                                *ngIf="!isCompartimenteDestinatieLoading && compartimenteDestinatieLoadComplete && compartimenteDestinatie.length === 0 && compartimenteDestinatieControl.value && compartimenteDestinatieControl.value.length >= 2">
                                                Nu au fost găsite rezultate
                                            </span>
                                        </mat-option>

                                        <mat-option *ngFor="let compartiment of compartimenteDestinatie"
                                            [value]="compartiment">
                                            {{ compartiment.name }}
                                        </mat-option>
                                    </mat-autocomplete>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <mat-form-field appearance="fill">
                                    <mat-label>Alegeți un operator</mat-label>
                                    <mat-select formControlName="user_id"
                                        (selectionChange)="onOperatoriDestinatieChange($event.value)">
                                        <!-- <mat-form-field class="px-2 sticky-input">
                                        <input matInput [formControl]="operatoriDestinatieControl"
                                            (keydown)="$event.stopPropagation()" (click)="$event.stopPropagation()" />
                                        </mat-form-field> -->

                                        <mat-option [value]="-1">-- Alegeți --</mat-option>

                                        <mat-option *ngFor="let operator of filteredOperatoriDestinatie"
                                            [value]="operator.id">
                                            {{ operator.name }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                        </div>

                        <button (click)="addDestinatieToTableData()" class="btn-search my-2 default-btn">
                            Adaugă Destinație
                        </button>
                    </form>

                    <div *ngIf="this.showFormDestinatie && this.tableData.length === 0" class="my-2">
                        <mat-error>Adăugați minim o destinație.</mat-error>
                    </div>

                    <div class="row m-2">
                        <table *ngIf="tableData.length > 0">
                            <thead>
                                <tr>
                                    <th class="pe-1">Crt.</th>
                                    <th class="pe-1">Instituție/Direcție</th>
                                    <th class="pe-1">Departament/Compartiment</th>
                                    <th class="pe-1">Responsabil</th>
                                    <th class="pe-1">Doc Original?</th>
                                    <th class="pe-1">#</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let row of tableData; let i = index" class="table-row">
                                    <td class="py-2 pe-1">{{ i + 1 }}</td>
                                    <td class="py-2 pe-1">{{ row.directie_name || 'n/a' }}</td>
                                    <td class="py-2 pe-1">{{ row.compartiment_name || 'n/a' }}</td>
                                    <td class="py-2 pe-1">{{ row.user_name || 'n/a' }}</td>
                                    <td class="py-2 pe-1">
                                        <button type="button" class="action-btn update_status_active"
                                            [ngClass]="(row.dosar_original ? 'action-success' : 'action-danger')"
                                            (click)="checkDocOriginal(i)">
                                            <img class="btn-img"
                                                [src]="row.dosar_original ? '/assets/icons/check-white.svg' : '/assets/icons/close-white.svg'" />
                                        </button>
                                    </td>
                                    <td class="py-2 pe-1">
                                        <button class="action-btn delete" (click)="deleteTableDataRow(i)">
                                            <img class="btn-img" src="../../../../assets/icons/delete.svg"
                                                alt="delete" />
                                        </button>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </ng-container>

                <div class="row">
                    <h5 class="mb-3"><span class="text-danger">*</span> <i>Câmpuri obligatorii</i></h5>
                    <div class="col d-flex gap-2 justify-content-between flex-wrap">
                        <button class="buttons" type="button" mat-stroked-button (click)="closeDialog()">
                            {{ helper.dialogConfig.buttonLabels.close }}
                        </button>
                        <div class="d-flex gap-2 flex-wrap">
                            <button class="buttons" type="submit" mat-flat-button color="primary"
                                (click)="submitForm()">
                                Înregistrează
                            </button>
                            <button class="buttons" type="submit" mat-flat-button color="success"
                                (click)="submitForm(true)">
                                Înregistrează și finalizează
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
        <!-- <div *ngIf="(inboxEmailsData || inboxAttachementsData) && selectedEmail" class="inbox-detail-right">
            <h3 class="m-0">Date email</h3>
            <mat-divider class="divider-section"></mat-divider>
            <br>
            <div class="email-info-section">
                <div class="info-row">
                    <strong>Subiect:</strong>
                    <span>{{ selectedEmail.subject }}</span>
                </div>
                <div class="info-row" *ngIf="selectedEmail.type === 'received'">
                    <strong>De la:</strong>
                    <span>{{ selectedEmail.from_name }} &lt;{{ selectedEmail.from_email
                        }}&gt;</span>
                </div>
                <ng-container *ngIf="selectedEmail.type !== 'received'">
                    <div class="info-row">
                        <strong>De la:</strong>
                        <span>{{ selectedEmail.sent_by_user_name }}</span>
                    </div>
                    <div class="info-row">
                        <strong>Către:</strong>
                        <span>{{ selectedEmail.to_name }} &lt;{{ selectedEmail.to_email }}&gt;</span>
                    </div>
                </ng-container>
                <div class="info-row">
                    <strong>CC:</strong>
                    <span>{{ selectedEmail.to_cc || '-' }}</span>
                </div>
                <div class="info-row">
                    <strong>Dată primit:</strong>
                    <span>{{ selectedEmail.received_date_time | date : "dd.MM.yyyy HH:mm" : "ro" }}</span>
                </div>
                <div class="info-row">
                    <strong>Dată procesat:</strong>
                    <span>{{ selectedEmail.created_date_time | date : "dd.MM.yyyy HH:mm" : "ro" }}</span>
                </div>

                <div class="info-badges">
                    <span class="badge badge-blue" *ngIf="selectedEmail.doc_intrare">
                        Înregistrat: {{ selectedEmail.doc_intrare.reg_number }} / {{
                        selectedEmail.doc_intrare.reg_date
                        | date : "dd.MM.yyyy" : "ro" }}
                    </span>
                    <span class="badge badge-orange" *ngIf="selectedEmail.assigned_user_id">
                        Operator: {{ selectedEmail.assigned_user_name }}
                    </span>
                    <span class="badge badge-green" *ngIf="selectedEmail.type_label">
                        {{ selectedEmail.type_label }}
                    </span>
                </div>
            </div>

            <h3 class="m-0">Conținut Email</h3>
            <mat-divider class="divider-section"></mat-divider>
            <br>
            <div class="email-content-section">
                <div class="email-body" [innerHTML]="getSafeHtml(selectedEmail.body || '-')"></div>
            </div>

            <h3 class="m-0">Atașamente ({{ selectedEmail.attachments.length }})</h3>
            <mat-divider class="divider-section"></mat-divider>
            <br>
            <div class="attachments-section"
                *ngIf="selectedEmail && selectedEmail.attachments && selectedEmail.attachments.length > 0">
                <div class="attachments-list">
                    <div class="attachment-item" *ngFor="let attachment of selectedEmail.attachments">
                        <div class="attachment-icon" [class.not-processed]="!attachment.processed_server">
                            <span class="file-extension">{{ attachment.extension.toUpperCase() }}</span>
                        </div>

                        <div class="attachment-info">
                            <div class="attachment-name" [title]="attachment.name_original">
                                {{ attachment.name_original }}
                            </div>
                            <div class="attachment-meta" *ngIf="attachment.doc_intrare">
                                <span class="meta-badge">
                                    Înregistrat: {{ attachment.doc_intrare.reg_number}} / {{
                                    attachment.doc_intrare.reg_date | date : "dd.MM.yyyy" : "ro"
                                    }}
                                </span>
                            </div>
                        </div>

                        <button *ngIf="attachment.processed_server" class="attachment-download"
                            (click)="downloadAttachment(attachment)" [title]="'Descarcă ' + attachment.name_original">
                            <i class="fa-solid fa-download"></i>
                            Descarcă
                        </button>
                    </div>
                </div>
            </div>
        </div> -->
        <div *ngIf="inboxEmailsData || inboxAttachementsData" class="inbox-detail-right">
            <!-- LISTĂ EMAILURI (când sunt mai multe și showEmailList = true) -->
            <div *ngIf="inboxEmailsData && inboxEmailsData.length > 1 && showEmailList" class="email-list-container">
                <h3 class="m-0">Emailuri selectate ({{ inboxEmailsData.length }})</h3>
                <mat-divider class="divider-section"></mat-divider>
                <br>

                <div class="emails-simple-list">
                    <div *ngFor="let email of inboxEmailsData; let i = index" class="email-list-item"
                        (click)="onSelectEmailFromList(email, i)">
                        <div class="email-list-item-header">
                            <span class="email-subject">{{ email.subject }}</span>
                            <span class="email-date">{{ email.received_date_time | date: 'dd.MM.yyyy' }}</span>
                        </div>
                        <div class="email-from">{{ email.from_name }}</div>
                    </div>
                </div>
            </div>

            <!-- DETALII EMAIL (când este selectat un email SAU este doar unul) -->
            <div *ngIf="(selectedInboxEmail && !showEmailList) || (inboxEmailsData && inboxEmailsData.length === 1) || inboxAttachementsData"
                class="email-details-container">

                <!-- Header cu navigare (doar dacă sunt mai multe emailuri) -->
                <div *ngIf="inboxEmailsData && inboxEmailsData.length > 1 && !showEmailList" class="email-navigation">
                    <button class="btn-back" (click)="onBackToEmailList()">
                        <i class="fa-solid fa-arrow-left"></i> Înapoi la listă
                    </button>
                    <div class="stepper-controls">
                        <button class="stepper-btn" [disabled]="currentEmailIndex === 0" (click)="onPreviousEmail()">
                            <i class="fa-solid fa-chevron-left"></i> Anterior
                        </button>
                        <span class="stepper-info">{{ currentEmailIndex + 1 }} / {{ inboxEmailsData.length }}</span>
                        <button class="stepper-btn" [disabled]="currentEmailIndex === inboxEmailsData.length - 1"
                            (click)="onNextEmail()">
                            Următor <i class="fa-solid fa-chevron-right"></i>
                        </button>
                    </div>
                </div>

                <h3 class="m-0">Date email</h3>
                <mat-divider class="divider-section"></mat-divider>
                <br>

                <div class="email-info-section">
                    <div class="info-row">
                        <strong>Subiect:</strong>
                        <span>{{ selectedEmail?.subject }}</span>
                    </div>
                    <div class="info-row" *ngIf="selectedEmail?.type === 'received'">
                        <strong>De la:</strong>
                        <span>{{ selectedEmail?.from_name }} &lt;{{ selectedEmail?.from_email }}&gt;</span>
                    </div>
                    <ng-container *ngIf="selectedEmail?.type !== 'received'">
                        <div class="info-row">
                            <strong>De la:</strong>
                            <span>{{ selectedEmail?.sent_by_user_name }}</span>
                        </div>
                        <div class="info-row">
                            <strong>Către:</strong>
                            <span>{{ selectedEmail?.to_name }} &lt;{{ selectedEmail?.to_email }}&gt;</span>
                        </div>
                    </ng-container>
                    <div class="info-row">
                        <strong>CC:</strong>
                        <span>{{ selectedEmail?.to_cc || '-' }}</span>
                    </div>
                    <div class="info-row">
                        <strong>Dată primit:</strong>
                        <span>{{ selectedEmail?.received_date_time | date : "dd.MM.yyyy HH:mm" : "ro" }}</span>
                    </div>
                    <div class="info-row">
                        <strong>Dată procesat:</strong>
                        <span>{{ selectedEmail?.created_date_time | date : "dd.MM.yyyy HH:mm" : "ro" }}</span>
                    </div>

                    <div class="info-badges">
                        <span class="badge badge-blue" *ngIf="selectedEmail?.doc_intrare">
                            Înregistrat: {{ selectedEmail?.doc_intrare?.reg_number }} / {{
                            selectedEmail?.doc_intrare?.reg_date | date : "dd.MM.yyyy" : "ro" }}
                        </span>
                        <span class="badge badge-orange" *ngIf="selectedEmail?.assigned_user_id">
                            Operator: {{ selectedEmail?.assigned_user_name }}
                        </span>
                        <span class="badge badge-green" *ngIf="selectedEmail?.type_label">
                            {{ selectedEmail?.type_label }}
                        </span>
                    </div>
                </div>

                <h3 class="m-0">Conținut Email</h3>
                <mat-divider class="divider-section"></mat-divider>
                <br>
                <div class="email-content-section">
                    <div class="email-body" [innerHTML]="selectedEmail?.body"></div>
                </div>

                <h3 class="m-0">Atașamente ({{ selectedEmail?.attachments?.length || 0 }})</h3>
                <mat-divider class="divider-section"></mat-divider>
                <br>
                <div class="attachments-section"
                    *ngIf="selectedEmail && selectedEmail.attachments && selectedEmail.attachments.length > 0">
                    <div class="attachments-list">
                        <div class="attachment-item" *ngFor="let attachment of selectedEmail.attachments">
                            <div class="attachment-icon" [class.not-processed]="!attachment.processed_server">
                                <span class="file-extension">{{ attachment.extension.toUpperCase() }}</span>
                            </div>

                            <div class="attachment-info">
                                <div class="attachment-name" [title]="attachment.name_original">
                                    {{ attachment.name_original }}
                                </div>
                                <div class="attachment-meta" *ngIf="attachment.doc_intrare">
                                    <span class="meta-badge">
                                        Înregistrat: {{ attachment.doc_intrare.reg_number}} / {{
                                        attachment.doc_intrare.reg_date | date : "dd.MM.yyyy" : "ro" }}
                                    </span>
                                </div>
                            </div>

                            <button *ngIf="attachment.processed_server" class="attachment-download"
                                (click)="downloadAttachment(attachment)"
                                [title]="'Descarcă ' + attachment.name_original">
                                <i class="fa-solid fa-download"></i>
                                Descarcă
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="section-spinner position-fixed" *ngIf="isLoading || isSelectedEmailLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>